<template>
  <div class="updateLog">
    <router-view></router-view>
    <ContentView  v-if="isDetail==false">
      <template slot="operateLeft">
        <div style="display:flex;">
          <el-input class="enter-input" v-model="searchVal"  size="small" placeholder="请输入内容" @keyup.enter.native="search"></el-input>
          <el-select @change="search" class="enter-input" size="small" v-model="typeName" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- <el-button style="margin-left: 15px;" size="small" @click="addNotice">新增</el-button> -->
      </template>
      <template slot="operateRight"></template>
      <el-table slot="contentBox" :data="tableData"  border  style="width: 100%">
        <el-table-column prop="phoneNumber" width="160" label="手机号"></el-table-column>
        <el-table-column prop="remarks" label="内容" ></el-table-column>
        <el-table-column prop="sendTime" label="发送时间" width="180"></el-table-column>
      </el-table>
       <template slot="pagnation">
        <el-pagination
          background
          @size-change="pageSizeChange"
          @current-change="pageCurrentChange"
          :page-sizes="[15, 20, 30, 50]"
          :page-size="15"
          layout="sizes, prev, pager, next"
          :total="total"
        ></el-pagination>
      </template>
    </ContentView>
  </div>
</template>
<script>
import ContentView from "@/components/ContentView";
import apiPub from '@/api/public'
export default {
  name: "oplog",
  data() {
    return {
      tableData: [],
      searchVal:"",
       options:[{
         label:"短信通知",
         value:"0"
       },{
         label:"电话通知",
         value:"1"
       }
      ],
      typeName:"",
      dialogFormVisible:false,
      form:{},
      input:"",
      win: false,
      total: 0,
      page:20,
      pageNum:1,
      timesRun: 0,
      isDetail:false
    };
  },
  components: {
    ContentView
  },
  watch:{
      $route(to,from){
        console.log(to);
        // this.controlRouter()
        if (to.name != 'oplog') {
          this.isDetail = true;
        } else {
          this.isDetail = false;
          this.search()
        }
    }
  },
  created() {
   console.log(this.$router)
    this.search();
    this.controlRouter()
  },
  methods: {
    
    //---------------查询区域--------begin-----------
    controlRouter() {
      console.log(this.$router.currentRoute)
       if (this.$router.currentRoute.name != 'oplog') {
        this.isDetail = true;
      } else {
        this.isDetail = false;
      }
    },
    search(){
      this.getlist()
    },
    addNotice(){
      this.$router.push({
        path: "/updateLog/updateForm",
        query: { }
      });
    },
    
    //---------------业务区域--------end-----------
    onSave(){
      
      var that=this;
      var obj = {
        "url": apiPub.AddNotice,
        "data":{
          "Content":this.form.Content,
          "Nstate":"0",
          "PushTime":this.form.PushTime,
          "PushUser":this.form.PushUser,
          "Title":this.form.Title
        }
      };
      $http.request(obj,false,function(res) {
        console.log(res)
        that.tableData=res.data;
      })
    },
    
    //---------------表格操作--------begin-----------
    getlist(){
      var that=this;
      var SearchText=this.searchVal||"";
      var userinfo = JSON.parse(localStorage.getItem("userinfo"));
      var obj = {
        "url": apiPub.SNSMsgList,
        "data":{
          "OrgCode":userinfo.orgCode,
          "SearchText":SearchText, 
          "UserId":userinfo.id,
          // "UserName":"姓名" ,
          "MessageType":this.typeName,
          "pageSize":this.page,
          "pageNum":this.pageNum-1
        }
      };
      $http.request(obj,false,function(res) {
        // console.log(res)
        that.tableData=res.data;
        that.total=res.totalNum;
      })
    },
   pageSizeChange(val) {
      var page = `${val}`;
      this.page = parseInt(page);
      this.getlist();
    },
    pageCurrentChange(val) {
     var pageNum = `${val}`;
       console.log(val)
      this.pageNum = parseInt(pageNum);
      this.getlist();
      
    },
    /// -----------------------分页--begin-----------------------------
    /// -----------------------分页--end-------------------------------
  }
};
</script>
<style scoped>
.enterprise {
  /* padding: 20px; */
  background: #fff;
}
.org-logo {
  width: 40px;
  height: 40px;
}
.enter-input{
    width: 200px;

}
.enter-input+.enter-input{
    margin-left: 15px;
}
.el-form-item{
    margin-bottom: 10px;
}
</style>
